import styled from "@emotion/styled";
import { DESKTOP, device } from "@/themes/device";
import {
  grayScale,
  mBody1,
  mBody2,
  mBody3,
  mHeader1,
  mTitle2,
  wArticle2,
  wBody2,
  wHeader2,
  wTitle2,
} from "@teamsparta/design-system";

export const Wrapper = styled.section``;

export const Top = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 328px;
  gap: 20px;
  margin: 0 auto 40px auto;
  @media ${device.desktop} {
    width: 100%;
    max-width: 1152px;
    align-items: center;
    gap: 30px;
    margin-bottom: 80px;
  }
`;
export const Title = styled.h3`
  ${mHeader1};
  color: ${grayScale.white};
  @media ${device.desktop} {
    ${wHeader2};
    color: ${grayScale.white};
    text-align: center;
  }
`;
export const Desc = styled.p`
  width: 328px;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 170%;
  color: #b4bfc6;

  @media ${device.desktop} {
    ${wArticle2};
    color: #d7e0e6;
    width: 647px;
    text-align: center;
  }
`;

export const AwardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  ${mBody3};
  color: #ffcb40;
  @media ${device.desktop} {
    flex-direction: row;
    gap: 22.5px;
    margin-bottom: 50px;
  }
`;
export const Award = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  @media ${device.desktop} {
    gap: 6.5px;
  }
`;
export const MobileCarouselContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 30px;
  overflow-x: scroll;
  margin-top: 20px;
  transform-style: preserve-3d;
  scroll-snap-type: x mandatory;
  transition: left 1s;
  padding-right: 26px;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  @media (min-width: 450px) {
    margin: 0 auto;
    width: 328px;
  }
  @media (max-width: 450px) {
    margin: 0 0 0 26px;
  }

  @media ${device.desktop} {
    display: none;
  }
`;

export const Slide = styled.div`
  width: 100%;
  min-width: 240px;
  scroll-snap-align: start;
  @media ${device.desktop} {
    width: 337px;
    min-width: initial;
    @media (max-width: 1152px) {
      width: 300px;
      height: 360px;
    }
  }
`;

export const Thumbnail = styled.div`
  width: 240px;
  height: 136px;
  @media ${device.desktop} {
    width: 337px;
    height: 191px;
    background: #3a3e41;
    border-radius: 8px;
  }
`;

export const ProjectName = styled.h6`
  ${mTitle2};
  color: ${grayScale.gray0};
  margin: 20px 0 8px 0;

  @media ${device.desktop} {
    ${wTitle2};
    color: ${grayScale.gray0};
    margin: 24px 0 10px 0;
  }
`;

export const ProjectDescription = styled.p`
  ${mBody2};
  color: ${grayScale.gray40};
  margin: 8px 0 0;

  @media ${device.desktop} {
    font-family: "Pretendard";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 180%;
    color: #c7d2d8;
  }
`;

export const ProjectLinkButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 96px;
  height: 32px;
  ${mBody1};
  font-size: 12px;
  color: ${grayScale.gray0};
  border: 1px solid ${grayScale.gray80};
  border-radius: 4px;
  margin: 20px 0 0;

  @media ${device.desktop} {
    width: 106px;
    height: 36px;
    font-size: 13px;
    margin: 24px 0 0;
  }
`;

export const DesktopCardContainer = styled.main`
  display: none;
  @media ${device.desktop} {
    display: flex;
    justify-content: space-between;
    padding: 0px;
    width: 100%;
    max-width: 1152px;
    height: 363px;
    margin: 0 auto;
  }
`;
